<dx-scroll-view #scrollView
    [scrollByContent]="true"
    [scrollByThumb]="true"
    showScrollbar="always">
    <div class="w-100 h-100 pe-1 pb-2 mb-2">
        <ng-content></ng-content>
    </div>
</dx-scroll-view>
